import * as React from 'react'

function Link(props) {
  return (
    <svg width="18" height="10" viewBox="0 0 18 10" fill="none" {...props}>
      <path
        d="M5.66675 1.66667C3.79365 1.66667 2.33341 3.1269 2.33341 5C2.33341 6.87308 3.79365 8.33333 5.66675 8.33333H7.33342C7.79366 8.33333 8.16675 8.70642 8.16675 9.16667C8.16675 9.62692 7.79366 10 7.33342 10H5.66675C2.87318 10 0.666748 7.79358 0.666748 5C0.666748 2.20643 2.87318 0 5.66675 0H7.33342C7.79366 0 8.16675 0.3731 8.16675 0.833333C8.16675 1.29357 7.79366 1.66667 7.33342 1.66667H5.66675ZM9.83342 0.833333C9.83342 0.3731 10.2065 0 10.6667 0H12.3334C15.127 0 17.3334 2.20643 17.3334 5C17.3334 7.79358 15.127 10 12.3334 10H10.6667C10.2065 10 9.83342 9.62692 9.83342 9.16667C9.83342 8.70642 10.2065 8.33333 10.6667 8.33333H12.3334C14.2065 8.33333 15.6667 6.87308 15.6667 5C15.6667 3.1269 14.2065 1.66667 12.3334 1.66667H10.6667C10.2065 1.66667 9.83342 1.29357 9.83342 0.833333ZM4.83342 5C4.83342 4.53975 5.20651 4.16667 5.66675 4.16667H12.3334C12.7937 4.16667 13.1667 4.53975 13.1667 5C13.1667 5.46025 12.7937 5.83333 12.3334 5.83333H5.66675C5.20651 5.83333 4.83342 5.46025 4.83342 5Z"
        fill="currentColor"
      />
    </svg>
  )
}

const MemoLink = React.memo(Link)
export default MemoLink
